import { saveAs } from 'file-saver';
import {
  Cell,
  Row,
  Workbook,
  Worksheet
} from 'exceljs';
import { IExcelColumnConfig } from 'src/app/models/excel-column-config.model';

export async function saveAsExcelFile(
  workbook: Workbook,
  name: string
): Promise<void> {
  const buffer = await workbook.xlsx.writeBuffer({
    useStyles: true,
    useSharedStrings: true
  });
  const file = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(file, `${name}.xlsx`);
}

export const setCellBorders = (cell: Cell) => {
  cell.border = {
    top: { style: 'thin', color: { argb: 'FF000000' } },
    left: { style: 'thin', color: { argb: 'FF000000' } },
    bottom: { style: 'thin', color: { argb: 'FF000000' } },
    right: { style: 'thin', color: { argb: 'FF000000' } }
  };
};

export const setCellBackgroundColor = (cell: Cell, color: string) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: color }
  };
};

export const setCellFont = (
  cell: Cell,
  isBold = false,
  color = 'FF000000'
) => {
  cell.font = {
    name: 'Arial',
    size: 10,
    bold: isBold,
    color: { argb: color }
  };
};

export const cellOverflowHidden = (cell: Cell) => {
  cell.alignment = {
    wrapText: true,
    vertical: 'middle',
    horizontal: 'left'
  };
};

export function addHeaderToExistingSheet(
  worksheet: Worksheet,
  config: IExcelColumnConfig[]
): void {
  const headerRow = worksheet.addRow(config.map(item => item.header));
  formatHeaderRow(headerRow);
  setColumnWidths(worksheet, config);
}

export function formatHeaderRow(headerRow: Row): void {
  headerRow.height = 22;
  headerRow.eachCell(cell => {
    setCellBorders(cell);
    setCellBackgroundColor(cell, 'FFE5E5E5');
    setCellFont(cell, true, 'FF000000');
    cellOverflowHidden(cell);
  });
}

export function setColumnWidths(
  worksheet: Worksheet,
  columnConfig: IExcelColumnConfig[]
): void {
  worksheet.columns = columnConfig.map(config => ({
    key: config.key,
    width: config.width || 18
  }));
}

export function freezeHeaderRow(worksheet: Worksheet, rowNumber: number): void {
  worksheet.views = [{ state: 'frozen', ySplit: rowNumber }];
}
